const constants = {
  storage: {
    ACCESS_TOKEN: 'access_token',
    ACCESS_TOKEN_EXPIRATION: 'access_token_expiration',
  }
};

export default constants;
